// extracted by mini-css-extract-plugin
module.exports = {"Container":"ListScreen_Container__1Lr4e","Card":"ListScreen_Card__3mTCH","SpinnerContainer":"ListScreen_SpinnerContainer__2KV2H","ExtraInfo":"ListScreen_ExtraInfo__1hXos"};